import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const WorkLiveContext = createContext(null);

export function WorkLiveProvider({ value, children }) {
  return (
    <WorkLiveContext.Provider value={value}>
      {children}
    </WorkLiveContext.Provider>
  );
}

WorkLiveProvider.propTypes = {
  value: PropTypes.object,
  children: PropTypes.node,
};

export function useWorkLive() {
  return useContext(WorkLiveContext);
}

export function useWorkLiveValue({
  taskId,
  taskStatus,
  taskError,
  isActive,
  activityStatus,
  activityIcon,
  activityStartedAt = null,
  lastEventAt,
  browserState,
  liveStartTs = null,
}) {
  return useMemo(() => ({
    taskId,
    taskStatus,
    taskError,
    isActive,
    activityStatus,
    activityIcon,
    activityStartedAt,
    lastEventAt,
    browserState,
    liveStartTs,
  }), [taskId, taskStatus, taskError, isActive, activityStatus, activityIcon, activityStartedAt, lastEventAt, browserState, liveStartTs]);
}
